import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';

function BinOutlineSmall(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 5.5H3.721l1.894 12.787a.25.25 0 00.248.213h8.274a.25.25 0 00.247-.213L16.28 5.5H6zm-5.05 0h1.255l1.927 13.006A1.75 1.75 0 005.862 20h8.275a1.75 1.75 0 001.731-1.494L17.795 5.5h1.255a.75.75 0 000-1.5h-4.359A4.751 4.751 0 005.31 4H.95a.75.75 0 000 1.5zM13.163 4a3.251 3.251 0 00-6.326 0h6.326zM10.75 8a.75.75 0 00-1.5 0v8a.75.75 0 001.5 0V8zm-4.343-.744a.75.75 0 01.837.651l1 8a.75.75 0 11-1.488.186l-1-8a.75.75 0 01.651-.837zm7.837.837a.75.75 0 10-1.488-.186l-1 8a.75.75 0 101.488.186l1-8z",
    clipRule: "evenodd"
  }));
}

export default BinOutlineSmall;
//# sourceMappingURL=BinOutlineSmall.js.map